import { useTranslation } from 'react-i18next'

import { Accordion } from '@/modules/shared/components/accordion/Accordion'
import CountBadge from '@/modules/shared/components/count-badge/CountBadge'
import { displayBadgeCount } from '@/modules/shared/components/count-badge/displayBadgeCount'
import { useGetDashboardStats } from '@/modules/shared/hooks/useGetDashboardStats'
import { BadgeIcon } from '@/modules/shared/icons-special/BadgeIcon'
import { EmailIcon } from '@/modules/shared/icons/EmailIcon'
import SideNavLink, { SideNavLinkItem } from '@/modules/shared/layouts/side-navigation/SideNavLink'
import { SideBarItem } from '@/modules/shared/layouts/side-navigation/purchaser-navigation/PurchaserNavigation'
import { Themes } from '@/modules/shared/types/Themes'

interface PaperlessEmailsSideBarItemProps extends SideBarItem {
  paperlessEmailsRoutesMatch: boolean
}

export const PaperlessEmailsSideBarItem = ({
  paperlessEmailsRoutesMatch,
  openAccordionKey,
  changeOpenAccordionKey,
  onCloseDrawer,
  sideBarIndexKey,
}: PaperlessEmailsSideBarItemProps) => {
  const { t } = useTranslation()
  const { dashboardStats } = useGetDashboardStats()

  const getSideNavLinkItems = () => {
    const sideNavItems: SideNavLinkItem[] = []
    sideNavItems.push(
      {
        key: t('general.viewAll', 'View All'),
        target: '/paperless-emails',
      },
      {
        key: t('general.actionItems', 'Action Items'),
        target: '/paperless-emails/action-items',
        icon: (
          <CountBadge displayText={displayBadgeCount(dashboardStats?.processDocumentsWithActionItemCount ?? 0, 25)} />
        ),
      },
      {
        key: t('general.scanningTasks', 'Scanning Tasks'),
        target: '/scanning-tasks',
      }
    )
    return sideNavItems
  }

  return (
    <Accordion
      titlePrefixIcon={
        <BadgeIcon isBadged={!!dashboardStats?.processDocumentsWithActionItemCount}>
          <EmailIcon className="size-7" />
        </BadgeIcon>
      }
      title={t('general.paperlessEmails', 'Paperless Emails')}
      activeColor={paperlessEmailsRoutesMatch ? Themes.Primary : undefined}
      defaultOpen={openAccordionKey === sideBarIndexKey}
      handleTriggerClick={() => changeOpenAccordionKey(sideBarIndexKey)}
      buttonClassName="min-h-11 px-3"
      keepActiveColor
    >
      <SideNavLink
        onCloseDrawer={() => onCloseDrawer()}
        testId="paperless-emails-navigation"
        sideNavLinkItems={getSideNavLinkItems()}
      />
    </Accordion>
  )
}
